export default __webpack_public_path__ + "static/media/39t.20af97de.jpg";